<template>
    <div id="main-content">
        <div id="tab-menu" class="container">
            <ul class="nav nav-tabs">
                <li class="active">
                    <a
                        data-toggle="tab"
                        id="step1"
                        class="disabled"
                        href="#home"
                        >User Information</a
                    >
                </li>
                <li>
                    <a
                        data-toggle="tab"
                        id="step2"
                        class="disabled"
                        href="#menu1"
                        >Organization Information</a
                    >
                </li>
            </ul>

            <div class="tab-content">
                <div id="home" class="tab-pane fade in active">
                    <form>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group row">
                                    <label
                                        class="col-sm-1 col-form-label"
                                    ></label>
                                    <div
                                        class="col-sm-10 pt-4 pb-2"
                                        style="text-align: left"
                                    >
                                        <label class="radio-inline"
                                            ><input
                                                type="radio"
                                                name="optradio"
                                                v-model="fdxType"
                                                value="FDX_MEMBER"
                                                disabled
                                            />FDX Member</label
                                        >
                                        <!-- <label class="radio-inline"
                                            ><input
                                                type="radio"
                                                name="optradio"
                                                v-model="fdxType"
                                                value="FDX_REGISTRANT"
                                                disabled
                                            />FDX Registrant</label
                                        > -->
                                        <label class="radio-inline"
                                            ><input
                                                type="radio"
                                                name="optradio"
                                                v-model="fdxType"
                                                value="FDX_OBSERVER"
                                                disabled
                                            />FDX Observer</label
                                        >
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="Prefix"
                                        class="col-sm-4 col-form-label"
                                        >Prefix</label
                                    >
                                    <div class="col-sm-7">
                                        <select
                                            class="form-control"
                                            id="Prefix"
                                            v-model="prefix"
                                        >
                                            <option>(None)</option>
                                            <option>Dr.</option>
                                            <option>Miss</option>
                                            <option>Mr.</option>
                                            <option>Mrs.</option>
                                            <option>Ms.</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="inputFirst"
                                        class="col-sm-4 col-form-label required"
                                        >First name</label
                                    >
                                    <div class="col-sm-7">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="fname"
                                            id="inputFirst"
                                        />
                                        <span
                                            class="valMsg"
                                            id="inputFirstVal"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="inputMiddle"
                                        class="col-sm-4 col-form-label"
                                        >Middle name</label
                                    >
                                    <div class="col-sm-7">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="mname"
                                            id="inputMiddle"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="inputLast"
                                        class="col-sm-4 col-form-label required"
                                        >Last name</label
                                    >
                                    <div class="col-sm-7">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="lname"
                                            id="inputLast"
                                        />
                                        <span
                                            class="valMsg"
                                            id="inputLastVal"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="Suffix"
                                        class="col-sm-4 col-form-label"
                                        >Suffix</label
                                    >
                                    <div class="col-sm-7">
                                        <select
                                            class="form-control"
                                            id="Suffix"
                                            v-model="suffix"
                                        >
                                            <option>(None)</option>
                                            <option>II</option>
                                            <option>III</option>
                                            <option>IV</option>
                                            <option>Jr.</option>
                                            <option>Sr.</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="inputTitle"
                                        class="col-sm-4 col-form-label required"
                                        >Organization Title</label
                                    >
                                    <div class="col-sm-7">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="orgTitle"
                                            id="inputTitle"
                                        />
                                        <span
                                            class="valMsg"
                                            id="inputTitleVal"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="inputOrgemail"
                                        class="col-sm-4 col-form-label required"
                                        >Business Email</label
                                    >
                                    <div class="col-sm-7">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="inputOrgemail"
                                            v-model="email"
                                            @blur="isEmailValid()"
                                            :disabled="emailVerified"
                                        />
                                        <img
                                            v-show="emailStatus == 'LOADING'"
                                            class="apiLoader"
                                            src="../assets/loading.png"
                                            alt="LOADING"
                                        />
                                        <a v-show="emailStatus == 'ERROR'">
                                            <span
                                                class="valMsg"
                                                id="inputOrgemailVal"
                                            />
                                        </a>
                                        <!-- <a
                                            type="button"
                                            id="verify-email"
                                            class="errormsg"
                                            v-show="emailStatus == 'VERIFY'"
                                            @click="sendEmail"
                                        >
                                            <em
                                                class="
                                                    fas
                                                    fa-exclamation-circle
                                                "
                                                style="color: #e26e25"
                                            ></em>
                                            Verify Email</a
                                        > -->
                                        <span
                                            class="verifyli pl-3"
                                            style="
                                                color: #1fa785;
                                                display: none;
                                            "
                                            v-show="this.emailVerified"
                                            id="valid_email_msg"
                                        >
                                            <em
                                                class="fas fa-check-circle"
                                                style="color: green"
                                            ></em>
                                            Validated</span
                                        >
                                        <span
                                            id="invalid_email_msg"
                                            style="display: none"
                                            v-show="emailStatus == 'INVALID'"
                                        >
                                            <span
                                                class="verifyli pl-3"
                                                style="color: #fe3a31"
                                            >
                                                <em
                                                    class="
                                                        fas
                                                        fa-exclamation-circle
                                                    "
                                                    style="color: red"
                                                ></em>
                                                Invalid Email</span
                                            >
                                            <a
                                                type="button"
                                                class="errormsg pl-3"
                                                style="color: #1fa785"
                                                @click="moreinfo"
                                                >More Info</a
                                            >
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="inputPhone"
                                        class="col-sm-4 col-form-label"
                                        >Phone</label
                                    >
                                    <div class="col-sm-7">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="phone"
                                            id="inputPhone"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="inputMobile"
                                        class="col-sm-4 col-form-label"
                                        >Mobile phone</label
                                    >
                                    <div class="col-sm-7">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="mobile"
                                            id="inputMobile"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="inputUser"
                                        class="col-sm-4 col-form-label"
                                        >Username</label
                                    >
                                    <div class="col-sm-7">
                                        <input
                                            type="text"
                                            disabled
                                            class="form-control"
                                            v-model="email"
                                            placeholder=""
                                            style="border: 1"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="inputPwd"
                                        class="col-sm-4 col-form-label required"
                                        >Password</label
                                    >
                                    <div class="col-sm-7">
                                        <input
                                            type="password"
                                            class="form-control"
                                            v-model="password"
                                            id="inputPwd"
                                        />
                                        <span class="valMsg" id="inputPwdVal" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="inputCpwd"
                                        class="col-sm-4 col-form-label required"
                                        >Confirm password</label
                                    >
                                    <div class="col-sm-7">
                                        <input
                                            type="password"
                                            class="form-control"
                                            v-model="cpassword"
                                            id="inputCpwd"
                                        />
                                        <span
                                            class="valMsg"
                                            id="inputCpwdVal"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div
                                    class="card"
                                    id="email_invalid"
                                    style="display: none"
                                >
                                    <h4>
                                        <strong
                                            >WHY WAS MY EMAIL INVALID?</strong
                                        >
                                    </h4>
                                    <p>
                                        FDX is comprised of member firms,
                                        companies, organizations and a limited
                                        number of industry leading individuals.
                                        In order to keep the FDX API, related
                                        artifacts and other documents
                                        confidential, FDX has a general policy
                                        of only distributing its materials to
                                        active businesses, firms, companies and
                                        other organizations with dedicated
                                        websites/emails (i.e., not to personal
                                        accounts such as Gmail, Yahoo, Hotmail,
                                        Yandex, etc.) with security protocols.
                                        We invite you to re-submit your request
                                        on behalf of your firm, company or other
                                        affiliated organization.
                                    </p>
                                    <br />
                                    <p>
                                        If your circumstance requires special
                                        consideration, please contact FDX’s
                                        General Counsel at
                                        <span style="color: #1fa785"
                                            >FDXLegal@financialdataexchange.org</span
                                        >
                                        with a description of your circumstances
                                        and reason for a waiver of this general
                                        policy.
                                    </p>
                                    <br />
                                    <p><strong>Thank you.</strong></p>
                                </div>
                            </div>
                        </div>
                        <p class="text-left" style="margin-left: 20px">
                            <em
                                >The password must be at least 8 characters long
                                and must contain at least 1 upper case, 1 lower
                                case and 1 number. Special characters -
                                *&%$#@!)( - are allowed.</em
                            >
                        </p>
                        <div class="form-group row">
                            <div class="col-md-2 col-sm-2 col-xs-6 text-left">
                                <button
                                    type="button"
                                    class="btn btn-default btn1 btn-block"
                                    data-toggle="modal"
                                    data-target="#myModal1"
                                >
                                    EXIT
                                </button>
                            </div>
                            <div class="col-sm-offset-8 col-md-2 col-sm-2 col-xs-6 text-right">
                                <button
                                    type="button"
                                    class="btn btn-default btn1 btn-block"
                                    @click="nextStep"
                                >
                                    NEXT
                                </button>
                            </div>
                        </div>

                    </form>
                </div>
                <!-- your information tab -->
                <div id="menu1" class="tab-pane fade">
                    <form>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group row">
                                    <label
                                        class="col-sm-8 col-form-label"
                                        style="color: #e26e25"
                                        >All fields required</label
                                    >
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="inputOrgname"
                                        class="col-sm-5 col-form-label"
                                        >Organization Name</label
                                    >
                                    <div class="col-sm-6">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="orgName"
                                            id="inputOrgname"
                                            @input="searchOrg"
                                            @blur="checkOrgExists()"
                                        />
                                        <div
                                            v-show="orgList && showOrgList"
                                            class="dropdown-list"
                                        >
                                            <option
                                                @click="selectedOrg(item)"
                                                v-for="item in orgList"
                                                :key="item.imisId"
                                                class="dropdown-item"
                                            >
                                                {{ item.name }}
                                            </option>
                                        </div>
                                        <img
                                            v-show="orgValidity === 'LOADING'"
                                            class="apiLoader"
                                            src="../assets/loading.png"
                                            alt="LOADING"
                                        />
                                        <span
                                            class="valMsg"
                                            id="inputOrgnameVal"
                                        />
                                        <a
                                            id="verify-ofac"
                                            class="verifyli pl-3"
                                            style="
                                                color: #1fa785;
                                                display: none;
                                            "
                                            v-show="orgValidity === 'true'"
                                        >
                                            <em
                                                class="fas fa-check-circle"
                                                style="color: green"
                                            ></em>
                                            Verified</a
                                        >
                                        <span
                                            id="invalid_ofac_msg"
                                            style="display: none"
                                            v-show="orgValidity === 'false'"
                                        >
                                            <span
                                                class="verifyli pl-3"
                                                style="color: #fe3a31"
                                            >
                                                <em
                                                    class="
                                                        fas
                                                        fa-exclamation-circle
                                                    "
                                                    style="color: red"
                                                ></em>
                                                Invalid Organization</span
                                            >
                                            <a
                                                type="button"
                                                class="errormsg pl-3"
                                                style="color: #1fa785"
                                                @click="moreinfoOfac"
                                                >More Info</a
                                            >
                                        </span>
                                        <span
                                            id="org_already_exists"
                                            style="display: none"
                                            v-show="orgExists == true"
                                        >
                                            <span
                                                class="verifyli pl-3"
                                                style="color: #fe3a31"
                                            >
                                                <em
                                                    class="
                                                        fas
                                                        fa-exclamation-circle
                                                    "
                                                    style="color: red"
                                                ></em>
                                                Organization Already
                                                Exists</span
                                            >
                                            <a
                                                type="button"
                                                class="errormsg pl-3"
                                                style="color: #1fa785"
                                                @click="
                                                    $router.push({
                                                        name: 'AccountViewOrganization',
                                                        query: {
                                                            prefix: prefix,
                                                            firstName: fname,
                                                            middleName: mname,
                                                            lastName: lname,
                                                            suffix: suffix,
                                                            title: orgTitle,
                                                        },
                                                    })
                                                "
                                                >Please select other
                                                participation option</a
                                            >
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="inputOrgaddress"
                                        class="col-sm-5 col-form-label"
                                        >Organization Address</label
                                    >
                                    <div class="col-sm-6">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="orgAddress"
                                            id="inputOrgaddress"
                                        />
                                        <span
                                            class="valMsg"
                                            id="inputOrgaddressVal"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="inputCity"
                                        class="col-sm-5 col-form-label"
                                        >Organization City</label
                                    >
                                    <div class="col-sm-6">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="orgCity"
                                            id="inputCity"
                                        />
                                        <span
                                            class="valMsg"
                                            id="inputCityVal"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="inputState"
                                        class="col-sm-5 col-form-label"
                                        >Organization State</label
                                    >
                                    <div class="col-sm-6">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="orgState"
                                            id="inputState"
                                        />
                                        <span
                                            class="valMsg"
                                            id="inputStateVal"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="inputZip"
                                        class="col-sm-5 col-form-label"
                                        >Organization Zip or Postal Code</label
                                    >
                                    <div class="col-sm-6">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="orgZip"
                                            id="inputZip"
                                        />
                                        <span class="valMsg" id="inputZipVal" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="selectCountry"
                                        class="col-sm-5 col-form-label"
                                        >Organization Country</label
                                    >
                                    <div class="col-sm-6">
                                        <select
                                            class="form-control"
                                            id="selectCountry"
                                            v-model="orgCountry"
                                        >
                                            <option
                                                v-for="country in orgCountries"
                                                :value="country.name"
                                                v-bind:key="country.countryId"
                                            >
                                                {{ country.name }}
                                            </option>
                                        </select>
                                        <span
                                            class="valMsg"
                                            id="selectCountryVal"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="selectType"
                                        class="col-sm-5 col-form-label"
                                        >Organization Type</label
                                    >
                                    <div class="col-sm-6">
                                        <select
                                            class="form-control"
                                            id="selectType"
                                            v-model="orgType"
                                        >
                                            <option
                                                v-for="(
                                                    otype, key
                                                ) in organizationTypes"
                                                :value="key"
                                                v-bind:key="otype.id"
                                            >
                                                {{ otype }}
                                            </option>
                                        </select>
                                        <span
                                            class="valMsg"
                                            id="selectTypeVal"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        for="selectLevel"
                                        class="col-sm-5 col-form-label"
                                        >Requested Membership Level</label
                                    >
                                    <div class="col-sm-6">
                                        <select
                                            class="form-control"
                                            id="selectLevel"
                                            v-model="orgMemberLevel"
                                            :disabled="this.fdxType === 'FDX_OBSERVER'"
                                        >
                                            <option
                                                v-for="(
                                                    level, key
                                                ) in membershipLevels"
                                                :value="key"
                                                v-bind:key="level.id"
                                            >
                                                {{ level }}
                                            </option>
                                        </select>
                                        <span
                                            class="valMsg"
                                            id="selectLevelVal"
                                        />
                                    </div>
                                </div>
                            </div>
                            <!-- more info -->
                            <div class="col-md-6">
                                <div
                                    class="card"
                                    id="ofac_invalid"
                                    style="display: none"
                                >
                                    <h4>
                                        <strong
                                            >WHY WAS MY ORGANIZATION
                                            INVALID?</strong
                                        >
                                    </h4>
                                    <p>
                                        The organization you entered is blocked
                                        and restricted as per OFAC guidelines.
                                    </p>
                                    <br />
                                </div>
                            </div>
                        </div>
                        <!-- more info end -->
                        <div class="text-left note">
                            <p style="font-size: 14px">
                                <strong>NOTE:</strong> FDX membership is
                                reserved for organizations. In rare instances,
                                it is extended to individuals who are experts in
                                their fields. If you still wish to apply as an
                                individual, please proceed with an application,
                                filling out your personal address and we will
                                contact you for additional information.
                            </p>
                            <br />
                            <div class="row">
                                <div class="col-sm-6">
                                    <p><strong>Greater of Entity Size or Revenue</strong></p>
                                </div>
                                <div class="col-sm-3">
                                    <p><strong>2024 Annual Dues - $USD**</strong></p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <p>Entities with assets > $500B or revenue > $5B</p>
                                </div>
                                <div class="col-sm-2">
                                    <span>$100,000</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <p>
                                        Entities with assets $50B - $500B or revenue $1B - $5B
                                    </p>
                                </div>
                                <div class="col-sm-2">
                                    <span>$75,000</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <p>
                                        Entities with assets $850M - $50B or revenue $500M - $1B
                                    </p>
                                </div>
                                <div class="col-sm-2">
                                    <span>$50,000</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <p>
                                        Entities with assets $500M - $850M or revenue $100M - $500M
                                    </p>
                                </div>
                                <div class="col-sm-2">
                                    <span>$25,000</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <p>
                                        Entities with assets $250M - $500M or revenue $25M - $100M
                                    </p>
                                </div>
                                <div class="col-sm-2">
                                    <span>$15,000</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <p>
                                        Entities with assets $100M - $250M or revenue $10M - $25M
                                    </p>
                                </div>
                                <div class="col-sm-2">
                                    <span>$10,000</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <p>Entities with assets &lt; $100M or revenue &lt; $10M</p>
                                </div>
                                <div class="col-sm-2">
                                    <span>$5,000</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <p>Non-profit entities, academics, universities***</p>
                                </div>
                                <div class="col-sm-2">
                                    <span>$1,000</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <p>Approved Individuals</p>
                                </div>
                                <div class="col-sm-2">
                                    <span>$99.00</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <p>Non-Commercial Group Members</p>
                                </div>
                                <div class="col-sm-2">
                                    <span>$0</span>
                                </div>
                            </div>
                            <br />
                            <p><strong>Membership Group Definitions</strong></p>
                            <p style="font-size: 14px">
                                <i
                                    ><strong
                                        >“Data Provider Group Members”</strong
                                    >
                                    or <strong>“DPGM”</strong> means
                                    organizations that:<br />
                                    (A) are primarily acting as a data providers
                                    (i.e., provide financial accounts to
                                    consumers (or act as custodians of consumer
                                    financial data)) and from which consumers
                                    may want to share their account data with
                                    authorized third parties, or<br />
                                    (B) are not, themselves, a data provider (as
                                    described in clause (A)), but are a trade or
                                    services organization primarily serving data
                                    providers. This could include a financial
                                    industry trade organization, or a service
                                    provider primarily to data providers
                                    (examples may include financial institutions
                                    (FIs), FI trades, FI utilities, core
                                    processors, payroll companies).*<br /><br />

                                    <strong>“Third Party Group Members”</strong>
                                    or <strong>“TPGM”</strong> means
                                    organizations that<br />

                                    (A) are primarily acting as authorized
                                    recipients of consumer-permissioned account
                                    information, or<br />
                                    (B) are for Persons that primarily serve
                                    authorized recipients of
                                    consumer-permissioned account information
                                    (for example, a trade organization or
                                    service provider to Third Party Group
                                    Members and/or data access
                                    platforms/aggregators - may include data
                                    access platforms/aggregators, apps, fintech
                                    trades)<br /><br />

                                    <strong
                                        >“Non-Commercial Group Members”</strong
                                    >
                                    or <strong>“NCGM”</strong> means
                                    organizations that<br />
                                    (A) do not meet the criteria of being a Data
                                    Provider Group Member or a Third Party Group
                                    Member, and<br />
                                    (B) do not represent or receive a vast
                                    majority of their funding/revenue from
                                    either Data Provider Group Members or Third
                                    Party Group Members (examples may include
                                    consumer groups, universities, standards
                                    bodies, academics, privacy groups). This
                                    designation would generally exclude vendors,
                                    consulting firms, and other service
                                    providers. Designation as a Non-Commercial
                                    Group Member is subject to approval by the
                                    Corporation.<br /><br />

                                    <strong
                                        >“Other Ecosystem Stakeholders”</strong
                                    >
                                    means organizations that are Members of the
                                    Corporation but are not a Data Provider
                                    Group Members, Third Party Group Members, or
                                    Non-Commercial Group Members. (examples may
                                    include: consultancies, security companies,
                                    law firms)<br /><br
                                /></i>
                            </p>
                            <p style="font-size: 14px">
                                *By registering and accepting the FDX API License Agreement,
                                you can become an FDX Observer and gain access to the FDX specification.
                                However, as an FDX Observer, you will not have access to the FDX registry,
                                FDX member materials, or artifacts. Additionally,
                                you will not be able to attend, access, or contribute to FDX working groups,
                                task forces, events, or any other forum activity.
                            </p>
                            <p style="font-size: 14px">
                                ** You can access the FDX specification without
                                becoming a member by registering and accepting
                                the FDX API License Agreement. As a FDX
                                Participant, you will not have access to FDX
                                member materials and artifacts, be able to
                                attend or contribute to committees or developer
                                meetups, or any other membership benefit.
                            </p>
                            <p style="font-size: 14px">
                                ***Non-Profits do not include entities with commercial interests,
                                 such as Credit Unions, whose fees are based on their revenues and
                                  not their “non-profit” status.
                            </p>
                            <p style="font-size: 14px">
                                ****Smaller entity qualifications and Non-Commercial Group Members are defined in the FDX Bylaws.
                                Generally, FDX defines a smaller Data Provider as having less than $10B USD in assets or less than
                                $500MM USD in revenue (or service providers whose customers are predominantly comprised of smaller
                                Data Providers). Smaller Third Party members are generally defined as having less than $100MM USD in
                                revenue (or service providers whose customers are predominantly comprised of smaller Third
                                Parties). “Noncommercial” entities are defined in FDX’s Bylaws and are generally service organizations
                                representing consumers or other similar interests that are not primarily funded by Data Providers or Third
                                Party entities.
                            </p>
                        </div>
                        <br /><br />
                        <div class="row">
                            <div class="col-sm-2   mb-3 mb-sm-0">
                                <button
                                    type="button"
                                    id="exit1"
                                    class="btn btn-default btn1 btn-block"
                                    data-toggle="modal"
                                    data-target="#myModal1"
                                >
                                    EXIT
                                </button>
                            </div>
                            <div class="col-sm-offset-6 col-sm-4 ">
                                <div class="row">
                                    <div class="col-6"> <button
                                        type="button"
                                        class="btn btn-default btn1 btn-block"
                                        @click="prevStep"
                                    >
                                        PREVIOUS
                                    </button></div>
                                    <div class="col-6">
                                         <button
                                        type="button"
                                        class="btn btn-default btn1 btn-block"
                                        @click="saveData"
                                    >
                                        FINISH
                                    </button></div>

                                </div>


                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="myModal" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Please verify your email before proceeding
                        </h4>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                        >
                            &times;
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>
                            A verification link has been sent to your email
                            inbox.
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-default btn1"
                            data-dismiss="modal"
                            @click="closeTab()"
                        >
                            CONTINUE
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="myModal1" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Are you sure you want to exit?
                        </h4>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                        >
                            &times;
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>All unsaved changes will be lost</p>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-default btn1"
                            data-dismiss="modal"
                            @click="abandonUser"
                        >
                            YES
                        </button>
                        <button
                            type="button"
                            class="btn btn-default btn1"
                            data-dismiss="modal"
                        >
                            NO
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="loading === true">
            <loader
                object="#1c71d8"
                color1="#ffffff"
                color2="#17fd3d"
                size="5"
                speed="2"
                bg="#343a40"
                objectbg="#999793"
                opacity="80"
                disableScrolling="false"
                name="dots"
            ></loader>
    </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import Toast from "../common/Toast";

export default {
    name: "AccountView",
    components: {},
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    created() {
        if (!(this.$route.query.membershipType || JSON.parse(this.$store.state.user))) {
            this.$router.push({name: "Get Started",});
        }
        if (this.$store.state.pageState === "thankyou") {
            this.$router.push({
                name: "thankyou",
            });
        }
        this.setUp();

        this.emailValidCheckMutation();

        this.unsubscribe = this.$store.subscribe((mutation) => {
            if (mutation.type === "setOfacValid" && mutation.payload !== null) {
                this.isOfacValid();
            }

            if (
                mutation.type === "createUserOrgResponse" &&
                mutation.payload !== null
            ) {
                if (
                    JSON.parse(this.$store.state.userOrgResponse).status ===
                    true
                ) {
                    this.$gtag.event("CreateUserOrg", {
                        event_category: "general",
                        event_label: "Created User and Organization",
                        email: JSON.parse(this.$store.state.user).email,
                        orgName: this.orgName.trim(),
                    });
                    this.$store.state.pageState = "thankyou";
                    this.$router.push("/login");
                }
            }

            if (
                mutation.type === "setOrganizationList" &&
                mutation.payload !== null
            ) {
                this.orgList = JSON.parse(this.$store.state.organizationList);
                this.orgValidity = null;
            }
        });
    },
    unmounted() {
        this.unsubscribe();
    },
    watch: {
        fname(val) {
            this.fname = val.replace(/[^A-Z.\-']/gi, "").substring(0, 64);
            document.getElementById("inputFirst").style.borderColor = "";
            document.getElementById("inputFirstVal").innerHTML = "";
        },
        mname(val) {
            this.mname = val.replace(/[^A-Z.\-' ]/gi, "").substring(0, 64);
        },
        lname(val) {
            this.lname = val.replace(/[^A-Z.\-']/gi, "").substring(0, 64);
            document.getElementById("inputLast").style.borderColor = "";
            document.getElementById("inputLastVal").innerHTML = "";
        },
        email(val) {
            document.getElementById("inputOrgemail").style.borderColor = "";
            document.getElementById("inputOrgemailVal").innerHTML = "";
            document.getElementById("email_invalid").style.display = "none";
            this.emailStatus = null;
            this.sameEmail = null;
            if (this.emailValid) {
                this.emailValid = null;
                this.$store.state.emailValid = null;
            }
            this.email = val.toLowerCase().substring(0, 255);
        },
        password(val) {
            this.password = val.substring(0, 32);
            document.getElementById("inputPwd").style.borderColor = "";
            document.getElementById("inputPwdVal").innerHTML = "";
        },
        cpassword() {
            document.getElementById("inputCpwd").style.borderColor = "";
            document.getElementById("inputCpwdVal").innerHTML = "";
        },
        orgTitle(val) {
            this.orgTitle = val.replace(/[^A-Z.\-' ]/gi, "").substring(0, 64);
            document.getElementById("inputTitle").style.borderColor = "";
            document.getElementById("inputTitleVal").innerHTML = "";
        },
        phone(val) {
            this.phone = val.replace(/[^0-9-/*#+.()]/gi, "").substring(0, 20);
        },
        mobile(val) {
            this.mobile = val.replace(/[^0-9-/*#+.()]/gi, "").substring(0, 20);
        },
        orgName(val) {
            this.orgName = val.replace(/[^A-Z0-9.\-',&@:;()!$£€¥*=#+% ]/gi, "").substring(0, 128);
            document.getElementById("inputOrgname").style.borderColor = "";
            document.getElementById("inputOrgnameVal").innerHTML = "";
            document.getElementById("ofac_invalid").style.display = "none";
            if (this.orgValidity) {
                this.orgValidity = null;
                this.$store.state.ofacValid = null;
            }
            this.orgExists = null;
            this.sameOrgName = null;
        },
        orgAddress(val) {
            this.orgAddress = val.substring(0, 40);
            document.getElementById("inputOrgaddress").style.borderColor = "";
            document.getElementById("inputOrgaddressVal").innerHTML = "";
        },
        orgCity(val) {
            this.orgCity = val.substring(0, 40);
            document.getElementById("inputCity").style.borderColor = "";
            document.getElementById("inputCityVal").innerHTML = "";
        },
        orgState(val) {
            this.orgState = val.substring(0, 50);
            document.getElementById("inputState").style.borderColor = "";
            document.getElementById("inputStateVal").innerHTML = "";
        },
        orgZip(val) {
            document.getElementById("inputZip").style.borderColor = "";
            document.getElementById("inputZipVal").innerHTML = "";
            this.orgZip = val
                .replace(/[^A-Z0-9]/gi, "")
                .toUpperCase()
                .substring(0, 10);
        },
        orgCountry() {
            document.getElementById("selectCountry").style.borderColor = "";
            document.getElementById("selectCountryVal").innerHTML = "";
        },
        orgType() {
            document.getElementById("selectType").style.borderColor = "";
            document.getElementById("selectTypeVal").innerHTML = "";
        },
        orgMemberLevel() {
            document.getElementById("selectLevel").style.borderColor = "";
            document.getElementById("selectLevelVal").innerHTML = "";
        },
        emailVerified: function (val) {
            if (val) {
                console.log("step2")
                document.getElementById("step2").click();
            }
        }
    },
    data() {
        return {
            fdxType: "FDX_OBSERVER",
            prefix: "",
            fname: "",
            mname: "",
            lname: "",
            suffix: "",
            orgTitle: "",
            email: "",
            phone: "",
            mobile: "",
            password: "",
            cpassword: "",
            orgName: "",
            orgAddress: "",
            orgCity: "",
            orgState: "",
            orgZip: "",
            orgCountries: [],
            orgCountry: "",
            orgType: null,
            orgMemberLevel: null,
            showModal: false,
            pwdreg: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d*&%$#@!)(]{8,}$/, // /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z0-9]{8,}$/,
            reg: /^[a-zA-Z\d_!#$%&'*+/=?`{|}~^.-]+@[a-zA-Z\d.-]+$/, //(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[\d]{1,3}\.[\d]{1,3}\.[\d]{1,3}\.[\d]{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,24}))$/,
            isValid: false,
            tempMsg: "",
            emailValid: null,
            sameEmail: null,
            emailStatus: null,
            emailVerified: null,
            membershipTypes: null,
            organizationTypes: [],
            membershipLevels: [],
            ofacValid: null,
            sameOrgName: null,
            orgValidity: null,
            orgList: null,
            showOrgList: false,
            orgExists: null,
            loading: false,
        };
    },
    methods: {
        ...mapActions([
            "checkEmailValid",
            "initiateVerifyEmail",
            "checkOfacValid",
            "getAbandonmentStatus",
            "initiateCreateUserOrg",
            "getOrganizationList",
        ]),

        setUp() {
            if (this.$route.query.membershipType) {
                this.fdxType = this.$route.query.membershipType;
            }
            if (this.$route.query.firstName) {
                this.prefix = this.$route.query.prefix;
                this.fname = this.$route.query.firstName;
                this.mname = this.$route.query.middleName;
                this.lname = this.$route.query.lastName;
                this.suffix = this.$route.query.suffix;
                this.orgTitle = this.$route.query.title;
                this.$store.state.user = null;
            }

            if (JSON.parse(this.$store.state.user)) {
                this.fdxType = JSON.parse(
                    this.$store.state.user
                ).membershipType;
                this.prefix = JSON.parse(this.$store.state.user).prefix;
                this.fname = JSON.parse(this.$store.state.user).firstName;
                this.mname = JSON.parse(this.$store.state.user).middleName;
                this.lname = JSON.parse(this.$store.state.user).lastName;
                this.suffix = JSON.parse(this.$store.state.user).suffix;
                this.orgTitle = JSON.parse(this.$store.state.user).title;
                this.email = JSON.parse(this.$store.state.user).email;
                this.phone = JSON.parse(this.$store.state.user).phone;
                this.mobile = JSON.parse(this.$store.state.user).mobile;
                this.password = window.atob(JSON.parse(this.$store.state.user).password);
                this.cpassword = this.password;
                this.emailVerified = true;
                this.sameEmail = this.email;
            }

            if (JSON.parse(this.$store.state.membershipTypes)) {
                this.membershipTypes = JSON.parse(
                    this.$store.state.membershipTypes
                );
            }
            if (JSON.parse(this.$store.state.organizationTypes)) {
                this.organizationTypes = JSON.parse(
                    this.$store.state.organizationTypes
                );
            }
            if (JSON.parse(this.$store.state.membershipLevels)) {
                this.membershipLevels = JSON.parse(
                    this.$store.state.membershipLevels
                );
            }
            if (JSON.parse(this.$store.state.countries)) {
                for (let key in JSON.parse(this.$store.state.countries)) {
                    let country = JSON.parse(this.$store.state.countries)[key];
                    this.orgCountries.push(country);
                }
            }
        },
        emailValidCheckMutation() {
            this.unsubscribe = this.$store.subscribe((mutation) => {
                if (
                    mutation.type === "setEmailValid" &&
                    mutation.payload !== null
                ) {
                    if (JSON.parse(this.$store.state.emailValid)) {
                        this.emailValid = JSON.parse(
                            this.$store.state.emailValid
                        );
                        if (
                            this.emailValid.status === false &&
                            this.emailValid.userExists === true
                        ) {
                            document.getElementById(
                                "inputOrgemail"
                            ).style.borderColor = "#FE3A31";
                            this.emailStatus = "ERROR";

                            if (this.emailValid.userActive === false) {
                                document.getElementById(
                                    "inputOrgemailVal"
                                ).innerHTML =
                                    "There is an issue with this email address. Please contact<a class='errormsg pl-3' style='color: #1fa785' href='" + "https://financialdataexchange.org/" + "FDX/Contact-Us.aspx' >FDX Support.</a >";
                                Toast.showToast(
                                    "There is an issue with this email address. Please contact FDX Support",
                                    "E"
                                );
                            } else {
                                document.getElementById(
                                    "inputOrgemailVal"
                                ).innerHTML =
                                    "This email address already exists.<a class='errormsg pl-3' style='color: #1fa785' href='/login' >Please sign in</a >";
                                Toast.showToast(
                                    "This email address already exists. Please sign in",
                                    "E"
                                );
                            }
                            this.emailVerified = false;
                        } else {
                            this.isEmailValid();
                        }
                    }
                }
            });
        },

        nextStep() {
            document.getElementById("inputFirst").style.borderColor = "";
            document.getElementById("inputFirstVal").innerHTML = "";
            document.getElementById("inputLast").style.borderColor = "";
            document.getElementById("inputLastVal").innerHTML = "";
            document.getElementById("inputOrgemail").style.borderColor = "";
            document.getElementById("inputOrgemailVal").innerHTML = "";
            document.getElementById("inputPwd").style.borderColor = "";
            document.getElementById("inputPwdVal").innerHTML = "";
            document.getElementById("inputCpwd").style.borderColor = "";
            document.getElementById("inputCpwdVal").innerHTML = "";
            const red = "#FE3A31";
            if (!this.fname) {
                Toast.showToast("First Name is Required", "E");
                document.getElementById("inputFirst").style.borderColor = red;
                document.getElementById("inputFirst").scrollIntoView(true);
                document.getElementById("inputFirstVal").innerHTML =
                    "First Name is Required";
                return;
            }
            if (!this.lname) {
                Toast.showToast("Last Name is Required", "E");
                document.getElementById("inputLast").style.borderColor = red;
                document.getElementById("inputLast").scrollIntoView(true);
                document.getElementById("inputLastVal").innerHTML =
                    "Last Name is Required";
                return;
            }
            if (!this.orgTitle) {
                Toast.showToast("Organization Title is Required", "E");
                document.getElementById("inputTitle").style.borderColor = red;
                document.getElementById("inputTitle").scrollIntoView(true);
                document.getElementById("inputTitleVal").innerHTML =
                    "Organization Title is Required";
                return;
            }
            if (!this.email) {
                Toast.showToast("Business Email is Required", "E");
                document.getElementById("inputOrgemail").style.borderColor =
                    red;
                document.getElementById("inputOrgemail").scrollIntoView(true);
                document.getElementById("inputOrgemailVal").innerHTML =
                    "Business Email is Required";
                this.emailStatus = "ERROR";
                return;
            }
            if (!this.reg.test(this.email)) {
                Toast.showToast("Please Enter Valid Email", "E");
                document.getElementById("inputOrgemail").style.borderColor =
                    "#FE3A31";
                document.getElementById("inputOrgemail").scrollIntoView(true);
                this.emailverification();
                return;
            }
            if (!this.password) {
                Toast.showToast("Password is Required", "E");
                document.getElementById("inputPwd").style.borderColor = red;
                document.getElementById("inputPwd").scrollIntoView(true);
                document.getElementById("inputPwdVal").innerHTML =
                    "Password is Required";
                return;
            }
            if (this.passwordCheck() === false) {
                return;
            }
            if (!this.cpassword) {
                Toast.showToast("Confirm Password is Required", "E");
                document.getElementById("inputCpwd").style.borderColor = red;
                document.getElementById("inputCpwd").scrollIntoView(true);
                this.tempMsg = "Confirm Password is Required";
                document.getElementById("inputCpwdVal").innerHTML =
                    this.tempMsg;
                return;
            }
            if (this.password != this.cpassword) {
                Toast.showToast(
                    "Password and Confirm Password should be same",
                    "E"
                );
                document.getElementById("inputCpwd").style.borderColor = red;
                document.getElementById("inputCpwd").scrollIntoView(true);
                this.tempMsg = "Password and Confirm Password should be same";
                document.getElementById("inputCpwdVal").innerHTML =
                    this.tempMsg;
                return;
            }
            // if (!this.emailVerified) {
            //     Toast.showToast("Please Verify Email", "E");
            //     document.getElementById("inputOrgemail").scrollIntoView(true);
            //     return;
            // }
            if (!this.emailVerified) {
                if (this.emailStatus !== 'VERIFY') {
                    Toast.showToast("Please Enter Valid Email", "E");
                    document.getElementById("inputOrgemail").scrollIntoView(true);
                    return;
                }
                this.sendEmail();
            } else {
                window.scrollTo(0, 0);
                document.getElementById("step2").click();
            }
        },
        prevStep() {
            window.scrollTo(0,0);
            document.getElementById("step1").click();
        },
        saveData() {
            const red = "#FE3A31";
            this.checkOrgExists();
            document.getElementById("inputOrgname").style.borderColor = "";
            document.getElementById("inputOrgnameVal").innerHTML = "";
            document.getElementById("inputOrgaddress").style.borderColor = "";
            document.getElementById("inputOrgaddressVal").innerHTML = "";
            document.getElementById("inputCity").style.borderColor = "";
            document.getElementById("inputCityVal").innerHTML = "";
            document.getElementById("inputState").style.borderColor = "";
            document.getElementById("inputStateVal").innerHTML = "";
            document.getElementById("inputZip").style.borderColor = "";
            document.getElementById("inputZipVal").innerHTML = "";
            document.getElementById("selectCountry").style.borderColor = "";
            document.getElementById("selectCountryVal").innerHTML = "";
            document.getElementById("selectType").style.borderColor = "";
            document.getElementById("selectTypeVal").innerHTML = "";
            document.getElementById("selectLevel").style.borderColor = "";
            document.getElementById("selectLevelVal").innerHTML = "";
            if (!this.orgName) {
                Toast.showToast("Organization Name is Required", "E");
                document.getElementById("inputOrgname").style.borderColor = red;
                document.getElementById("inputOrgname").scrollIntoView(true);
                document.getElementById("inputOrgnameVal").innerHTML =
                    "Organization Name is Required";
                return;
            }
            if (this.orgExists === true) {
                Toast.showToast("Organization Already Exists", "E");
                document.getElementById("inputOrgname").style.borderColor = red;
                document.getElementById("inputOrgname").scrollIntoView(true);
                return;
            }
            if (this.orgValidity !== "true") {
                Toast.showToast("Organization Name is Not Valid", "E");
                document.getElementById("inputOrgname").style.borderColor = red;
                document.getElementById("inputOrgname").scrollIntoView(true);
                return;
            }
            if (!this.orgAddress) {
                Toast.showToast("Organization Address is Required", "E");
                document.getElementById("inputOrgaddress").style.borderColor =
                    red;
                document.getElementById("inputOrgaddress").scrollIntoView(true);
                document.getElementById("inputOrgaddressVal").innerHTML =
                    "Organization Address is Required";
                return;
            }
            if (!this.orgCity) {
                Toast.showToast("Organization City is Required", "E");
                document.getElementById("inputCity").style.borderColor = red;
                document.getElementById("inputCity").scrollIntoView(true);
                document.getElementById("inputCityVal").innerHTML =
                    "Organization City is Required";
                return;
            }
            if (!this.orgState) {
                Toast.showToast("Organization State is Required", "E");
                document.getElementById("inputState").style.borderColor = red;
                document.getElementById("inputState").scrollIntoView(true);
                document.getElementById("inputStateVal").innerHTML =
                    "Organization State is Required";
                return;
            }
            if (!this.orgZip) {
                Toast.showToast(
                    "Organization Zip or Postal Code is Required",
                    "E"
                );
                document.getElementById("inputZip").style.borderColor = red;
                document.getElementById("inputZip").scrollIntoView(true);
                document.getElementById("inputZipVal").innerHTML =
                    "Organization Zip or Postal Code is Required";
                return;
            }
            if (!this.orgCountry) {
                Toast.showToast("Organization Country is Required", "E");
                document.getElementById("selectCountry").style.borderColor =
                    red;
                document.getElementById("selectCountry").scrollIntoView(true);
                document.getElementById("selectCountryVal").innerHTML =
                    "Organization Country is Required";
                return;
            }
            if (!this.orgType) {
                Toast.showToast("Organization Type is Required", "E");
                document.getElementById("selectType").style.borderColor = red;
                document.getElementById("selectType").scrollIntoView(true);
                document.getElementById("selectTypeVal").innerHTML =
                    "Organization Type is Required";
                return;
            }
            if (this.fdxType === 'FDX_MEMBER' && !this.orgMemberLevel) {
                Toast.showToast(
                    "Organization Membership Level is Required",
                    "E"
                );
                document.getElementById("selectLevel").style.borderColor = red;
                document.getElementById("selectLevel").scrollIntoView(true);
                document.getElementById("selectLevelVal").innerHTML =
                    "Organization Membership Level is Required";
                return;
            }

            if (this.prefix === "(None)") {
                this.prefix = "";
            }
            if (this.suffix === "(None)") {
                this.suffix = "";
            }

            let request = {
                membershipType: this.fdxType,
                prefix: this.prefix,
                firstName: this.fname,
                middleName: this.mname,
                lastName: this.lname,
                suffix: this.suffix,
                title: this.orgTitle.trim(),
                email: this.email.trim(),
                phone: this.phone,
                mobile: this.mobile,
                password: window.btoa(this.password),
                organizationRequest: {
                    name: this.orgName.trim(),
                    address: this.orgAddress.trim(),
                    city: this.orgCity.trim(),
                    state: this.orgState.trim(),
                    zipcode: this.orgZip,
                    country: this.orgCountry,
                    organizationType: this.orgType,
                    membershipLevel: this.orgMemberLevel,
                },
            };
            this.loading = true;
            this.$store.state.user = JSON.stringify(request);
            this.initiateCreateUserOrg(request);
        },
        passwordCheck() {
            const red = "#FE3A31";
            if (!/^[a-zA-Z\d*&%$#@!)(]*$/.test(this.password)) {
                Toast.showToast(
                    "Password Can Only Contain Alphanumeric Characters, *,&,%,$,#,@ And !",
                    "E"
                );
                document.getElementById("inputPwd").style.borderColor = red;
                document.getElementById("inputPwd").scrollIntoView(true);
                document.getElementById("inputPwdVal").innerHTML =
                    "Can Only Contain Alphanumeric Characters, *,&,%,$,#,@ And !";
                return false;
            }
            if (!/^[a-zA-Z\d*&%$#@!)(]{8,}$/.test(this.password)) {
                Toast.showToast(
                    "Minimum 8 Characters Is Required For Password",
                    "E"
                );
                document.getElementById("inputPwd").style.borderColor = red;
                document.getElementById("inputPwd").scrollIntoView(true);
                document.getElementById("inputPwdVal").innerHTML =
                    "Minimum 8 Characters Is Required";
                return false;
            }
            if (!/^(?=.*\d)[a-zA-Z\d*&%$#@!)(]{8,}$/.test(this.password)) {
                Toast.showToast(
                    "At Least 1 Digit Is Required For Password",
                    "E"
                );
                document.getElementById("inputPwd").style.borderColor = red;
                document.getElementById("inputPwd").scrollIntoView(true);
                document.getElementById("inputPwdVal").innerHTML =
                    "At Least 1 Digit Is Required";
                return false;
            }
            if (
                !/^(?=.*\d)(?=.*[a-z])[a-zA-Z\d*&%$#@!)(]{8,}$/.test(
                    this.password
                )
            ) {
                Toast.showToast(
                    "At Least 1 Lowercase Alphabet Is Required For Password",
                    "E"
                );
                document.getElementById("inputPwd").style.borderColor = red;
                document.getElementById("inputPwd").scrollIntoView(true);
                document.getElementById("inputPwdVal").innerHTML =
                    "At Least 1 Lowercase Alphabet Is Required";
                return false;
            }
            if (
                !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d*&%$#@!)(]{8,}$/.test(
                    this.password
                )
            ) {
                Toast.showToast(
                    "At Least 1 Uppercase Alphabet Is Required For Password",
                    "E"
                );
                document.getElementById("inputPwd").style.borderColor = red;
                document.getElementById("inputPwd").scrollIntoView(true);
                document.getElementById("inputPwdVal").innerHTML =
                    "At Least 1 Uppercase Alphabet Is Required";
                return false;
            }
            return true;
        },
        moreinfo() {
            document.getElementById("email_invalid").style.display = "block";
        },
        moreinfoOfac() {
            document.getElementById("ofac_invalid").style.display = "block";
        },
        isEmailValid() {
            if (this.email !== "" && !this.reg.test(this.email)) {
                this.emailStatus = "INVALID";
            }
            if (
                this.email !== "" &&
                this.reg.test(this.email) &&
                this.email !== this.sameEmail
            ) {
                let request = this.email.trim();
                this.emailStatus = "LOADING";
                this.checkEmailValid(request);
                this.sameEmail = this.email;
                this.emailValid = null;
                this.emailVerified = false;
            }
            if (this.emailVerified) {
                return null;
            }
            if (JSON.parse(this.$store.state.emailValid)) {
                this.emailValid = JSON.parse(this.$store.state.emailValid);
                this.sameEmail = this.email;
            }
            if (this.emailValid) {
                if (this.emailValid.status === true) {
                    this.emailStatus = "VERIFY";
                    document.getElementById("inputOrgemail").style.borderColor =
                        "#0e8bbc";
                    document.getElementById("invalid_email_msg").style.display =
                        "none";
                } else {
                    this.emailStatus = "INVALID";
                    if (this.emailValid.userExists === true) {
                        this.emailStatus = "ERROR";
                    }
                }
            }
        },
        emailverification() {
            document.getElementById("invalid_email_msg").style.display =
                "inline";
            document.getElementById("verify-email").style.display = "none";
        },
        sendEmail() {
            this.loading = true;
            let request = {
                membershipType: this.fdxType,
                prefix: this.prefix,
                firstName: this.fname,
                middleName: this.mname,
                lastName: this.lname,
                suffix: this.suffix,
                title: this.orgTitle.trim(),
                email: this.email.trim(),
                phone: this.phone,
                mobile: this.mobile,
                password: window.btoa(this.password)
            };
            this.$gtag.event("sendEmail", {
                event_category: "general",
                event_label: "Email Sent For Verification",
                value: this.email.trim(),
            });
            this.initiateVerifyEmail(request);
        },
        respVerifyEmail() {
            this.loading = false;
            $("#myModal").modal("show");
        },
        closeTab() {
            window.open(
                "https://financialdataexchange.org/" + "FDX/FDX/Default.aspx?hkey=bd839735-ebf5-426a-91f9-8334cbae1438",
                "_self"
            );
        },
        abandonUser() {
            if (this.email) {
                this.getAbandonmentStatus(this.email);
                this.$gtag.event("abandonUser", {
                    event_category: "general",
                    event_label: "User abandon at sign up",
                    value: this.email.trim(),
                });
            } else {
                this.$gtag.event("abandonUser", {
                    event_category: "general",
                    event_label: "User abandon at sign up",
                    value: "Unknown",
                });
            }
            this.closeTab();
        },
        isOfacValid() {
            let valid = null;
            if (
                this.orgName !== "" &&
                this.orgName !== this.sameOrgName &&
                this.orgExists === false
            ) {
                let request = this.orgName.trim();
                valid = "LOADING";
                this.$gtag.event("checkOfacValid", {
                    event_category: "general",
                    event_label: "Check Organization Ofac Validity",
                    email: this.email.trim(),
                    orgName: this.orgName.trim(),
                });
                this.checkOfacValid(request);
                this.sameOrgName = this.orgName;
                this.ofacValid = null;
            }
            if (JSON.parse(this.$store.state.ofacValid)) {
                this.ofacValid = JSON.parse(this.$store.state.ofacValid);
                this.sameOrgName = this.orgName;
                if (this.ofacValid.status) {
                    valid = "true";
                } else {
                    valid = "false";
                }
            }
            if (this.orgName === "") {
                valid = null;
            }
            this.orgValidity = valid;
        },

        searchOrg() {
            if (this.orgName.length >= 3) {
                this.orgValidity = "LOADING";
                this.getOrganizationList(this.orgName);
                this.showOrgList = true;
            } else {
                this.showOrgList = false;
            }
        },
        selectedOrg(item) {
            const red = "#FE3A31";
            this.orgName = item.name;
            this.showOrgList = false;
            document.getElementById("inputOrgname").style.borderColor = red;
            this.orgExists = true;
        },
        checkOrgExists() {
            setTimeout(() => {
                this.showOrgList = false;
                let exists = false;
                for (let org of this.orgList) {
                    if (
                        org.name.trim().toLowerCase() ===
                        this.orgName.trim().toLowerCase()
                    ) {
                        exists = true;
                        this.orgValidity = null;
                        this.$store.state.ofacValid = null;
                        break;
                    }
                }
                this.orgExists = exists;
                this.isOfacValid();
            }, 1000);
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
    padding: 10px;
}

a[disabled],
a[disabled]:hover {
    pointer-events: none;
    color: #e1e1e1;
}

.note {
    margin-left: 20px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #1978a0;
}

.container {
    box-sizing: border-box;
    max-width: 1123px;
    height: auto;
    left: 159px;
    top: 240px;
}

#tab-menu h3 {
    color: white;
    background-color: #428bca;
    padding: 5px 15px;
}

.tab-content {
    border-style: solid;
    border-color: #ddd;
    border-width: 0 1px 1px 1px;
    padding: 10px;
    border-top: 3px solid #1978a0;
    /* height: 800px; */
}

.nav-tabs > li.active > a,
.nav-tabs > li.active > a:focus,
.nav-tabs > li.active > a:hover {
    background: #1978a0;
    width: 200px;
    height: 46px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #ffffff;
}

.nav-tabs > li > a {
    background: #f6f5f5;
    border: 1px solid #d8d8d8;
    width: 200px;
    height: 46px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #5a7d95;
    padding: 15px 15px;
    margin-right: 0px;
}

.col-form-label {
    text-align: left;
    margin-left: 20px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #5a7d95;
}

.form-control {
    background: #ffffff;
    border: 1px solid #0e8bbc;
    border-radius: 6px;
}

.form-control:focus {
    border: 1px solid #0e8bbc;
    box-shadow: 0px 0px 5px rgba(15, 109, 219, 0.3);
}

.form-control:active {
    border: 1px solid #0e8bbc;
    box-shadow: 0px 0px 5px rgba(15, 109, 219, 0.3);
}

.btn1 {
    background: #019382;
    border-radius: 6px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #ffffff;
    height: 45px;
}

.verifyli {
    font-size: 12px;
    line-height: 24px;
    float: left;
    color: #e26e25;
}

.errormsg {
    font-size: 12px;
    line-height: 24px;
    float: left;
    text-decoration-line: underline;
    color: #e26e25;
}

.nav.nav-tabs li:not(:first-of-type) a {
    pointer-events: none !important;
}

.modal-title {
    font-size: 20px;
    line-height: 22px;
    color: #1978a0;
}

.modal-body {
    font-size: 14px;
    line-height: 20px;
    color: #5a7d95;
    text-align: left;
}

.card {
    border-top: 2px solid #fe3a31 !important;
    background: #f6f5f5;
    margin-top: 20px;
    margin-right: 20px;
    text-align: left;
    color: #5a7d95;
    padding: 10px;
    line-height: 22px;
    border-style: none;
}

.hide_property {
    display: none;
}

.show_property {
    display: inline;
    float: left;
}

.required:after {
    content: " *";
    color: red;
}

.valMsg {
    color: red;
    font-size: 12px;
    line-height: 24px;
    float: left;
}

.dropdown-list {
    position: absolute !important;
    width: 100%;
    max-height: 500px;
    margin-top: 4px;
    overflow-y: auto;
    background: #ffffff;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
        0 4px 6px -2px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    z-index: 1000;
}
/deep/.dropdown-list {
    position: absolute !important;
}
.dropdown-item {
    display: flex;
    width: 100%;
    padding: 11px 16px;
    cursor: pointer;
}
.dropdown-item:hover {
    background: #edf2f7;
}
.dropdown-item-flag {
    max-width: 24px;
    max-height: 18px;
    margin: auto 12px auto 0px;
}

.apiLoader {
    width: 20px;
}
.col-sm-offset-8 {
    margin-left: 66.66666667% !important;
}
.col-sm-offset-6 {
    margin-left: 50% !important;
}

@media (max-width: 600px) {

    .nav-tabs>li.active>a,
    .nav-tabs>li.active>a:focus,
    .nav-tabs>li.active>a:hover {


        max-width: 193px !important;

    }

    .nav-tabs>li>a {

        max-width: 193px !important;
    }

}

@media(max-width:575px) {

    .col-sm-offset-8 {
        margin-left: 0% !important;
    }
    .col-sm-offset-6 {
        margin-left: 0% !important;
    }
}

@media (max-width: 425px) {

    .nav-tabs>li.active>a,
    .nav-tabs>li.active>a:focus,
    .nav-tabs>li.active>a:hover {

        max-width: 172.5px !important;

    }

    .col-sm-offset-8 {
        margin-left: 0px !important;
    }

    .nav-tabs>li>a {
        max-width: 172.5px !important;
    }



}

@media (max-width: 378px) {

    .nav-tabs>li.active>a,
    .nav-tabs>li.active>a:focus,
    .nav-tabs>li.active>a:hover {

        max-width: 151.5px !important;

    }

    .nav-tabs>li>a {
        max-width: 151.5px !important;
    }

}

@media (max-width: 360px) {

    .nav-tabs>li.active>a,
    .nav-tabs>li.active>a:focus,
    .nav-tabs>li.active>a:hover {

        max-width: 165px !important;

    }

    .nav-tabs>li>a {
        max-width: 165px !important;
    }

}

@media (max-width: 328px) {

    .nav-tabs>li.active>a,
    .nav-tabs>li.active>a:focus,
    .nav-tabs>li.active>a:hover {

        width: 144.5px !important;

    }

    .nav-tabs>li>a {
        width: 145.5px !important;
    }

}
</style>
